import React, { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import "./index.css";

// Initialize EmailJS with your public key
emailjs.init("ODQ47UuA_hp145hOx");

const App = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: ''
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
    setIsSubmitted(false);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsSubmitted(false);
    setFormData({ fullName: '', mobileNumber: '' });
    document.body.style.overflow = 'auto';
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare template parameters
    const templateParams = {
      from_name: formData.fullName,
      mobile_number: formData.mobileNumber,
    };

    console.log('Sending email with params:', templateParams);

    // Send email using EmailJS
    emailjs
      .send(
        "service_cmm7idn",      // Your Service ID
        "template_cx8af7h",     // Your Template ID
        templateParams
      )
      .then(
        (response) => {
          console.log('✅ EMAIL SENT SUCCESSFULLY!');
          console.log('Response Status:', response.status);
          console.log('Response Text:', response.text);
          setIsSubmitted(true);
          
          // Auto close after 3 seconds
          setTimeout(() => {
            closeModal();
          }, 3000);
        },
        (error) => {
          console.error('❌ EMAIL FAILED TO SEND');
          console.error('Error Object:', error);
          console.error('Error Status:', error.status);
          console.error('Error Text:', error.text);
          alert("Failed to send your inquiry. Please try again or contact us directly.");
        }
      );
  };

  const concerns = [
    { name: "Chuti group", link: "https://www.facebook.com/chutigroup.org/", icon: "fa-building" },
    { name: "Chuti Resort Gazipur", link: "https://chutiresort.com/", icon: "fa-hotel" },
    { name: "Chuti Resort Purbachal", link: "https://chutiresortpurbachal.com/", icon: "fa-hotel" },
    { name: "Chuti Aronnobash Resort", link: "https://chutiaronnobash.com/", icon: "fa-tree" },
    { name: "Chuti Forest Eagle Resort", link: "https://www.facebook.com/chutiforesteagleresort/", icon: "fa-dove" },
    { name: "Chuti Beach Resort", link: "https://chutibeachresort.com/", icon: "fa-umbrella-beach" },
    { name: "Chuti Harmony", link: "https://www.chutiharmony.com/", icon: "fa-spa" },
    { name: "Chuti Signature", link: "https://www.facebook.com/chutisignature/", icon: "fa-gem" },
    { name: "Chuti Valley", link: "https://www.facebook.com/chutivalley/", icon: "fa-mountain-sun" },
    { name: "Saltanat Tea Resort", link: "https://www.facebook.com/saltanattearesort/", icon: "fa-mug-hot" },
    { name: "Saltanat Highway Village", link: "https://www.facebook.com/SaltanatHighwayVillage.bd/", icon: "fa-road" },
    { name: "Chutir Janala", link: "https://www.facebook.com/chutirjanala.org/?_rdr", icon: "fa-window-maximize" },
    
  ];


  return (
    <div className="main-container">
      {/* Animated Background Elements */}
      <div className="bg-decoration">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="logo-container">
            <img src="/logo.png" alt="Chuti group Logo" className="logo" />
          </div>
          <p className="hero-subtitle">Since 2012</p>
         
        </div>
      </section>

      {/* Concerns Section */}
      <section id="concerns" className="concerns">
        <div className="section-header">
          <h2 className="section-title">Concerns of Chuti group</h2>
          <p className="section-subtitle">
          Experience the art of hospitality with our exclusive resorts — where luxury meets leisure, and every detail is designed around you.
          </p>
        </div>
        <div className="concern-grid">
          {concerns.map((c, index) => (
            <a
              key={index}
              href={c.link}
              target="_blank"
              rel="noopener noreferrer"
              className="concern-card"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="concern-icon">
                <i className={`fas ${c.icon}`}></i>
              </div>
              <h3 className="concern-name">{c.name}</h3>
              <div className="concern-arrow">
                <i className="fas fa-arrow-right"></i>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Why Choose & Trust Section */}
      <section className="why-section">
        <div className="why-container">
          <div className="why-card">
            <div className="why-icon">
              <i className="fas fa-heart"></i>
            </div>
            <h3>Why Choose Chuti?</h3>
            <ul>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>Premium Quality Hospitality Services</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>Immersive Natural Beauty & Serenity</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>Luxurious Amenities & Ultimate Comfort</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>Exceptional Customer Service Excellence</span>
              </li>
            </ul>
          </div>
          <div className="why-card">
            <div className="why-icon">
              <i className="fas fa-shield-halved"></i>
            </div>
            <h3>Why Trust Chuti?</h3>
            <ul>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>12+ Years of Industry Experience</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>Thousands of Happy Guests Annually</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>Award-Winning Service & Facilities</span>
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                <span>Commitment to Guest Satisfaction</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Our Clients Section */}
      <section className="clients-section">
        <div className="section-header">
          <h2 className="section-title">Our Trusted Partners</h2>
          <p className="section-subtitle">
            Proudly serving leading organizations across industries
          </p>
        </div>
        <div className="clients-slider">
          <div className="clients-track">
            {/* First set of logos */}
            <div className="client-logo">
              <img src="/Our-Client/AB_Bank-removebg-preview.original.png" alt="AB Bank" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Amercani-removebg-preview.original.png" alt="Amercani" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Apex_holding-removebg-preview.original.png" alt="Apex Holding" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/CEDC-removebg-preview.original.png" alt="CEDC" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/City_Bank-removebg-preview.original.png" alt="City Bank" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Levi-removebg-preview.original.png" alt="Levi's" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Medtronic-removebg-preview.original.png" alt="Medtronic" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Meghna_Goup-removebg-preview.original.png" alt="Meghna Group" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/New_Zealand-removebg-preview.original.png" alt="New Zealand" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/oracle-removebg-preview.original.png" alt="Oracle" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Partex-removebg-preview.original.png" alt="Partex" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/robi-axiata-seeklogo_BW-01.original.png" alt="Robi Axiata" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/rpac-removebg-preview.original.png" alt="RPAC" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Sumitomo-removebg-preview.original.png" alt="Sumitomo" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/syngenta-removebg-preview.original.png" alt="Syngenta" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/technogym-removebg-preview.original.png" alt="Technogym" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Total-removebg-preview.original.png" alt="Total" />
            </div>
            
            {/* Duplicate set for seamless loop */}
            <div className="client-logo">
              <img src="/Our-Client/AB_Bank-removebg-preview.original.png" alt="AB Bank" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Amercani-removebg-preview.original.png" alt="Amercani" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Apex_holding-removebg-preview.original.png" alt="Apex Holding" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/CEDC-removebg-preview.original.png" alt="CEDC" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/City_Bank-removebg-preview.original.png" alt="City Bank" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Levi-removebg-preview.original.png" alt="Levi's" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Medtronic-removebg-preview.original.png" alt="Medtronic" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Meghna_Goup-removebg-preview.original.png" alt="Meghna Group" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/New_Zealand-removebg-preview.original.png" alt="New Zealand" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/oracle-removebg-preview.original.png" alt="Oracle" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Partex-removebg-preview.original.png" alt="Partex" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/robi-axiata-seeklogo_BW-01.original.png" alt="Robi Axiata" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/rpac-removebg-preview.original.png" alt="RPAC" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Sumitomo-removebg-preview.original.png" alt="Sumitomo" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/syngenta-removebg-preview.original.png" alt="Syngenta" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/technogym-removebg-preview.original.png" alt="Technogym" />
            </div>
            <div className="client-logo">
              <img src="/Our-Client/Total-removebg-preview.original.png" alt="Total" />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Us Button Section */}
      <section className="contact-us-section">
        <button className="contact-us-btn" onClick={openModal}>
          <i className="fas fa-envelope"></i>
          Contact Us
        </button>
      </section>

      {/* Contact Form Modal */}
      <div className={`modal-overlay ${isModalOpen ? 'active' : ''}`} onClick={closeModal}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          {!isSubmitted ? (
            <>
              <div className="modal-header">
                <h2>Get In Touch</h2>
                <button className="modal-close" onClick={closeModal}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="fullName">
                    <i className="fas fa-user"></i>
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="Enter your full name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobileNumber">
                    <i className="fas fa-mobile-alt"></i>
                    Mobile Number
                  </label>
                  <input
                    type="tel"
                    id="mobileNumber"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    placeholder="Enter your mobile number"
                    pattern="[0-9+\-\s]+"
                    required
                  />
                </div>
                <button type="submit" className="form-submit">
                  <i className="fas fa-paper-plane"></i> Submit
                </button>
              </form>
            </>
          ) : (
            <div className="success-message active">
              <i className="fas fa-check-circle"></i>
              <h3>Thank You!</h3>
              <p>We've received your information. Our team will contact you soon.</p>
            </div>
          )}
        </div>
      </div>

      {/* Premium Footer */}
      <footer className="footer">
        <div className="footer-wave">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
          </svg>
        </div>
        
        <div className="footer-container">
          <div className="footer-main">
            <div className="footer-column footer-about">
              <div className="footer-logo-qr-container">
                <div className="footer-logo-section">
                  <img src="/logo.png" alt="Chuti group" className="footer-logo-img" />
                </div>
                <div className="footer-qr-section">
                  <img src="/qr.jpg" alt="Chuti group QR Code" className="footer-qr-img" />
                </div>
              </div>
              <p className="footer-description">
                Scan me
              </p>
              <div className="footer-social">
                <a href="https://www.facebook.com/chutigroup.org/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/chuti_group/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.youtube.com/channel/UC6R5RKFnO8xbaM_aJp3jmJA" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="fab fa-youtube"></i>
                </a>
                <a href="https://www.linkedin.com/company/chuti-group/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>

            <div className="footer-column footer-contact">
              <h4>Head Office</h4>
              <div className="footer-contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <p>House-47, Road-27, Block-A Level-7<br/>Banani, Dhaka -1213</p>
              </div>
              <div className="footer-contact-item">
                <i className="fas fa-phone-alt"></i>
                <p>+880 1401-102144</p>
              </div>
            </div>

            <div className="footer-column footer-contact">
              <h4>Corporate Office</h4>
              <div className="footer-contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <p>House-61, Road-27 Block-K<br/>Level 3,4 & 5, Banani, Dhaka -1213</p>
              </div>
              <div className="footer-contact-item">
                <i className="fas fa-phone-alt"></i>
                <p>+880 1922-603358</p>
              </div>
              <div className="footer-contact-item">
                <i className="fas fa-phone-alt"></i>
                <p>+880 1401-102121</p>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="copyright">
                © {new Date().getFullYear()} <strong>Chuti group</strong>. All Rights Reserved.
              </p>
              <div className="footer-bottom-links">
                <a href="#">Privacy Policy</a>
                <span>•</span>
                <a href="#">Terms of Service</a>
                <span>•</span>
                <a href="#">Cookie Policy</a>
              </div>
              <p className="footer-tagline">
              Crafted with passion by Chuti Branding Department
              </p>
            </div>
          </div>
        </div>

        <div className="footer-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      {scrolled && (
        <button
          className="scroll-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Scroll to top"
        >
          <i className="fas fa-arrow-up"></i>
        </button>
      )}

      {/* Floating Contact Buttons */}
      <div className="floating-contacts">
        <a 
          href="tel:+8801711139884" 
          className="floating-btn floating-call"
          aria-label="Call us"
        >
          <i className="fas fa-phone-alt"></i>
          <span className="floating-tooltip">Call: +880 1711-139884</span>
        </a>
        <a 
          href="https://wa.me/8801332544649" 
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn floating-whatsapp"
          aria-label="WhatsApp us"
        >
          <i className="fab fa-whatsapp"></i>
          <span className="floating-tooltip">WhatsApp: +880 1332-544649</span>
        </a>
      </div>
    </div>
  );
};

export default App;
